/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}[_nghost-%COMP%]   .loading-container[_ngcontent-%COMP%]{background-color:#fff;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;padding-bottom:3em;height:100%}[_nghost-%COMP%]   .loading-container[_ngcontent-%COMP%]   .loader[_ngcontent-%COMP%]{width:4em;height:4em;border-width:.5em}.activity-player[_ngcontent-%COMP%]{border:0;width:100%;height:100%}"];
export { styles as styles };
//# sourceMappingURL=activity-player.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/activity-player/activity-player.component.scss.shim.ngstyle.js
// module id = 1307
// module chunks = 27 28 29